{
  "doka": {
    "labelReset": "Réinitialiser",
    "labelDefault": "Par défaut",
    "labelAuto": "Auto",
    "labelNone": "Aucun",
    "labelEdit": "Modifier",
    "labelClose": "Fermer",
    "labelLandscape": "Paysage",
    "labelPortrait": "Portrait",
    "labelSizeExtraSmall": "Très petit",
    "labelSizeSmall": "Petit",
    "labelSizeMediumSmall": "Moyen petit",
    "labelSizeMedium": "Moyen",
    "labelSizeMediumLarge": "Moyen grand",
    "labelSizeLarge": "Grand",
    "labelSizeExtraLarge": "Très grand",
    "labelButtonRevert": "Revenir",
    "labelButtonCancel": "Annuler",
    "labelButtonUndo": "Annuler",
    "labelButtonRedo": "Refaire",
    "labelButtonExport": "Fait",
    "statusLabelButtonClose": "Fermer",
    "cropLabel": "Recadrer",
    "cropLabelButtonRecenter": "Recentrer",
    "cropLabelButtonRotateLeft": "Tourner à gauche",
    "cropLabelButtonRotateRight": "Tourner à droite",
    "cropLabelButtonFlipHorizontal": "Basculer horizontalement",
    "cropLabelButtonFlipVertical": "Basculer verticalement",
    "cropLabelSelectPreset": "Forme du recadrement",
    "cropLabelCropBoundary": "Limite du recadrement",
    "cropLabelCropBoundaryEdge": "Bord de l'image",
    "cropLabelCropBoundaryNone": "Aucun",
    "cropLabelTabRotation": "Rotation",
    "cropLabelTabZoom": "Zoom",
    "filterLabel": "Filtrer",
    "filterLabelChrome": "Chrome",
    "filterLabelFade": "Fané",
    "filterLabelCold": "Froid",
    "filterLabelWarm": "Chaud",
    "filterLabelPastel": "Pastel",
    "filterLabelMonoDefault": "Mono",
    "filterLabelMonoNoir": "Noir",
    "filterLabelMonoWash": "Wash",
    "filterLabelMonoStark": "Stark",
    "filterLabelSepiaDefault": "Sepia",
    "filterLabelSepiaBlues": "Bleus",
    "filterLabelSepiaRust": "Rouille",
    "filterLabelSepiaColor": "Couleur",
    "finetuneLabel": "Affiner",
    "finetuneLabelBrightness": "Luminosité",
    "finetuneLabelContrast": "Contraste",
    "finetuneLabelSaturation": "Saturation",
    "finetuneLabelExposure": "Exposition",
    "finetuneLabelTemperature": "Température",
    "finetuneLabelGamma": "Gamma",
    "finetuneLabelClarity": "Clarté",
    "finetuneLabelVignette": "Vignette",
    "imageTooSmall": "Cette image est trop petite. Veuillez en téléverser une d'au moins {minLongSide}×{minShortSide} pixels (paysage ou portrait)",
    "imageTooLarge": "Cette image est trop volumineuse. Veuillez en téléverser une de {maxSizeMb} Mo ou moins.",
    "imageCropBelowSource": "Ce recadrage est trop petit et réduirait la qualité de la photo. Utilisez toute la surface de l'image ou téléversez une photo en plus haute résolution.",
    "imageReadError": "Impossible de lire cette image. Essayez un autre fichier ou format.",
    "notSupportedOnThisBrowser": "non supporté par ce navigateur",
    "waitingForImage": "En attente de l'image",
    "errorLoadingImage": "Erreur de chargement de l'image",
    "creatingPreview": "Création d'un aperçu…",
    "loadingImage": "Chargement de l'image…",
    "errorUploadingImage": "Erreur de téléchargement de l'image",
    "uploadingImage": "Téléchargement de l'image…",
    "errorProcessingImage": "Erreur de traitement de l'image",
    "processingImage": "Traitement de l'image…",
    "unsupportedType": "Le format de fichier {extension} n'est pas pris en charge. Formats autorisés : {extensions}"
  }
}
